import { Formik, Form, Field, ErrorMessage } from "formik";

type Props = {
    setSearch: Function;
    setPage: Function;
};

const SearchBox = (props: Props) => {
    return (
        <div className="card-toolbar">
            <div className="py-2 me-20">
                <Formik
                    initialValues={{
                        searchBy: "productName",
                        searchName: "",
                    }}
                    // validationSchema={searchSchema}
                    onSubmit={({ searchBy, searchName }, onSubmitProps) => {
                        let genericName = "";
                        let productName = "";
                        if (searchBy === "productName") {
                            props.setPage(1);
                            props.setSearch({
                                genericName,
                                productName: searchName?.trim(),
                            });
                            onSubmitProps.resetForm();
                        }
                        if (searchBy === "genericName") {
                            props.setPage(1);
                            props.setSearch({
                                genericName: searchName?.trim(),
                                productName,
                            });
                            onSubmitProps.resetForm();
                        }
                    }}
                >
                    {(formProps) => {
                        const placeholderText =
                            formProps?.values?.searchBy === "productName"
                                ? "Product Name"
                                : "Generic Name";
                        return (
                            <Form className="w-100 d-flex flex-column align-items-center justify-content-center">
                                <div className="d-flex">
                                    <div className="d-flex me-5">
                                        <Field
                                            name="searchBy"
                                            as="select"
                                            className="form-control form-select form-control-solid"
                                        >
                                            <option
                                                value="productName"
                                                selected
                                            >
                                                Product Name
                                            </option>
                                            <option value="genericName">
                                                Generic Name
                                            </option>
                                        </Field>
                                    </div>
                                    <div className="d-flex">
                                        <Field
                                            name="searchName"
                                            placeholder={`Search by ${placeholderText}`}
                                            className="form-control form-control-lg form-control-solid"
                                        />
                                        <button
                                            disabled={
                                                formProps.isSubmitting ||
                                                !(
                                                    formProps.isValid &&
                                                    formProps.dirty
                                                )
                                            }
                                            type="submit"
                                            className="ms-3 btn btn-sm btn-primary"
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div className="w-100 d-flex flex-column align-items-center text-danger mt-1">
                                    <ErrorMessage name="searchName" />
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

export default SearchBox;
